export const customerReviews = [
  {
    "name": "Ananya Mehta",
    "location": "Mumbai, India",
    "message": "Health Plus helped me book an appointment with a specialist instantly. The doctor was attentive and guided me through my treatment."
  },
  {
    "name": "Ravi Verma",
    "location": "Delhi, India",
    "message": "I had a great experience consulting online for my migraine issue. Quick response and very professional doctors."
  },
  {
    "name": "Priya Sharma",
    "location": "Bangalore, India",
    "message": "Smooth booking, friendly staff, and excellent follow-up. Health Plus made it so convenient during my health checkup."
  },
  {
    "name": "Amit Singh",
    "location": "Chandigarh, India",
    "message": "I received a fast consultation for my child's fever and got a digital prescription in minutes. Highly recommended!"
  },
  {
    "name": "Kavita Iyer",
    "location": "Pune, India",
    "message": "I used the platform for dental care and the experience was very pleasant. The doctor was very skilled and made me feel at ease."
  },
  {
    "name": "Neeraj Joshi",
    "location": "Ahmedabad, India",
    "message": "Professional services with real-time support. I got a heart specialist's advice from the comfort of my home."
  },
  {
    "name": "Simran Kaur",
    "location": "Ludhiana, India",
    "message": "The app is user-friendly, and the medical team is responsive. I love how easily I can access all my reports."
  },
  {
    "name": "Arjun Nair",
    "location": "Kochi, India",
    "message": "Excellent teleconsultation! I was treated with respect, and all my doubts were cleared patiently by the doctor."
  },
  {
    "name": "Meena Reddy",
    "location": "Hyderabad, India",
    "message": "Being a working mom, Health Plus saved me time and stress. Got my prescriptions renewed in just a few clicks!"
  },
  {
    "name": "Rahul Patil",
    "location": "Nagpur, India",
    "message": "Great experience overall. Timely consultation, polite staff, and easy to use interface. Truly a modern health solution."
  }
];
